import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getVirtualsConfig() {
    return {
        palette: {
            [PALETTE_IDS.VIRTUALS]: {
                VIRTUALS_EVENT_NAME_TEXT: {
                    color: COLOR.BRAND.FOREGROUND5,
                    fontWeight: FONT.WEIGHT_BOLD,
                    textTransform: 'normal',
                    fontSize: FONT.SIZE_MEDIUM,
                },
                VIRTUALS_MOBILE_RACE_DETAILS_TEXT: COLOR.BRAND.FOREGROUND5,

                VIRTUALS_EVENT_SELECTOR_BG: COLOR.BRAND.BACKGROUND5,
                VIRTUALS_EVENT_SELECTOR_BOTTOM_DIVIDER: COLOR.BASE.PAGE,

                VIRTUALS_STREAM_CONTAINER_BG: COLOR.BRAND.BACKGROUND5,
                VIRTUALS_NEXT_EVENT_COUNTDOWN_TEXT: COLOR.BRAND.FOREGROUND2,
                VIRTUALS_NEXT_EVENT_COUNTDOWN_BG: COLOR.BRAND.BACKGROUND2,
                MOBILE_SPORT_SELECTOR_CONTAINER: COLOR.BRAND.BACKGROUND5,
            },
        },
    };
}
